import React, { useContext, useEffect, useRef, useState } from "react";
import { animated, useSpring } from "@react-spring/three";
import { useGLTF } from "@react-three/drei";
import CurrentContext from "./CurrentContext";
import useSetMaterialFinish from "./useTextureCustom";
import { handleExportGLTF } from "./utils/jsHelpers";
import { useControls } from "leva";
import { Deg0, Deg90CCW } from "./utils/AnimaonSprings";
import * as THREE from "three";

export default function Model_san_jaun() {
  return (
    <>
      <Model_san_jaun_big />
      {/* <Model_san_jaun_small/> */}
    </>
  );
}

export function Model_san_jaun_big() {
  const { nodes, materials, scene } = useGLTF("models/san_jaun.glb");
  const [finishes, setFinishes] = useState({});
  const [tileFinishes, setTileFinishes] = useState({});
  //  const { posx, posy, posz,argx,argy,argz} = useControls({
  //   posx: { value: 0, min: -2, max: 2, step: 0.001 },
  //   posy: { value: 0, min: -2, max: 2, step: 0.001 },
  //   posz: { value: 0, min: -2, max: 2, step: 0.001 },
  //   argx: { value: 0, min: -2, max: 2, step:0.001 },
  //   argy: { value: 0, min: -2, max: 2, step:0.001 },
  //   argz: { value: 0, min: -2, max: 2, step:0.001 },
  // });

  const {
    grill,
    setGrill,
    siding,
    setSiding,
    door,
    setDoor,
    colorScheme,
    setcolorScheme,
    loading,
    setLoading,
    isARReady,
    setIsARReady,
    ARModelSrc,
    setARModelSrc,
    ARUnicode,
    setARUnicode,
    isAR,
    setIsAR,
    umbrellHole,
    setUmbrellHole,
    bottleOpener,
    setBottleOpener,
    sideBurner,
    refrigerator,
    animation,
    tileColorScheme,
    setTileColorScheme,
    refrigeratorType,
    groutColor,
    setGroutColor,
  } = useContext(CurrentContext);

  useEffect(() => {
    if (siding === "Quartzite") {
      if (colorScheme === "Sandstone Tan SR12") {
        setFinishes({
          diffuseMap: "../textures/big/quartzite-sandstone-tan.jpg",
          displacementMap: null,
          normalMap: "../textures/big/normal_quartzite-sandstone-tan.jpg",
          normalScale: [0.3, 0.3],
          repeat: [8, 8],
          // aoMap1: refrigerator ? '../textures/big/san_jaun_qurtize_base_with_fridge_ao.jpg' : '../textures/big/san_jaun_qurtize_base_without_fridge_ao.jpg'
        });
      }
      if (colorScheme === "Misty Gray SR16") {
        setFinishes({
          diffuseMap: "../textures/big/quartzite-misty-gray.jpg",
          displacementMap: null,
          normalMap: "../textures/big/normal_quartzite-misty-gray.jpg",
          normalScale: [0.3, 0.3],
          repeat: [8, 8],
          // aoMap1: refrigerator ? '../textures/big/san_jaun_qurtize_base_with_fridge_ao.jpg' : '../textures/big/san_jaun_qurtize_base_without_fridge_ao.jpg'
        });
      }
    } else if (siding === "Faux Rock") {
      if (colorScheme === "Gray") {
        setFinishes({
          diffuseMap: "../textures/big/fauxrock-gray.jpg",
          aoMap: "../textures/big/bbq_faux_brick_ao.jpg",
          normalMap: "../textures/big/faux_brick_normal.png",
          normalScale: [1, 1],
          // aoMap1: refrigerator ? '../textures/big/san_jaun_qurtize_base_with_fridge_ao.jpg' : '../textures/big/san_jaun_qurtize_base_without_fridge_ao.jpg'
        });
      }
      if (colorScheme === "Brown") {
        setFinishes({
          diffuseMap: "../textures/big/fauxrock-brown.jpg",
          aoMap: "../textures/big/bbq_faux_brick_ao.jpg",
          normalMap: "../textures/big/faux_brick_normal.png",
          normalScale: [1, 1],
          // aoMap1: refrigerator ? '../textures/big/san_jaun_qurtize_base_with_fridge_ao.jpg' : '../textures/big/san_jaun_qurtize_base_without_fridge_ao.jpg'
        });
      }
    } else if (siding === "No Siding") {
      setFinishes({
        diffuseMap: "../textures/big/no-siding-1k.jpeg",
        displacementMap: null,
        // normalMap: "../textures/big/normal_quartzite-misty-gray.jpg",
        normalScale: [1, 1],
        repeat: [5, 5],
        // aoMap1: refrigerator ? '../textures/big/san_jaun_qurtize_base_with_fridge_ao.jpg' : '../textures/big/san_jaun_qurtize_base_without_fridge_ao.jpg'
      });
    }
    {
      if (tileColorScheme === "Chocolate") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-chocolate.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
          // aoMap1: '../textures/big/san_jaun_top_AO.jpg',
        });
        setGroutColor({
          color: "#928272",
        });
      }
      if (tileColorScheme === "Civic Sand") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-civic-sand.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
          // aoMap1: '../textures/big/san_jaun_top_AO.jpg',
        });
        setGroutColor({
          color: "#e5e3dec7",
        });
      }
      if (tileColorScheme === "Notable beige") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-notable-beige.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
          // aoMap1: '../textures/big/san_jaun_top_AO.jpg',
        });
        setGroutColor({
          color: "#eeebe5",
        });
      }
      if (tileColorScheme === "Park Lane Gray") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-park-lane-gray.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
          // aoMap1: '../textures/big/san_jaun_top_AO.jpg',
        });
        setGroutColor({
          color: "#c6ccd4",
        });
      }
      if (tileColorScheme === "Union smoke") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-union-smoke.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
          // aoMap1: '../textures/big/san_jaun_top_AO.jpg',
        });
        setGroutColor({
          color: "#8c95a2",
        });
      }
      if (tileColorScheme === "Iron Gray") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-iron-gray.jpg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
          // aoMap1: '../textures/big/san_jaun_top_AO.jpg',
        });
        setGroutColor({
          color: "#818084",
        });
      }
      if (tileColorScheme === "No Tile") {
        setTileFinishes({
          diffuseMap: "../textures/big/no-siding-1k.jpeg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
          // aoMap1: '../textures/big/san_jaun_top_AO.jpg',
        });
        setGroutColor({
          color: "#818084",
        });
      }
    }
  }, [siding, colorScheme, tileColorScheme]);

  useSetMaterialFinish(materials.siding, finishes, setLoading);

  useSetMaterialFinish(materials.top_side_frame, groutColor, setLoading);

  useSetMaterialFinish(materials.top, tileFinishes, setLoading);

  const { rotation_Grill } = useSpring({
    rotation_Grill: animation ? Deg90CCW : Deg0,
    config: { duration: 1000 },
    delay: animation ? 500 : 0,
  });

  const { rotation_Side_burner } = useSpring({
    rotation_Side_burner: animation ? Deg90CCW : Deg0,
    config: { duration: 1000 },
    delay: animation ? 0 : 500,
  });

  return (
    <group dispose={null} visible={true}>
      {/* 30" Double Door */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["door-double_door"].geometry}
        material={materials.double_door}
        visible={door === '30" Double Door' ? true : false}
      />
      {refrigeratorType !== "None" ? (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.refrigerator.geometry}
            material={materials.refrigerator}
            visible={refrigeratorType === "Standard Fridge" ? true : false}
          >
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.refrigerator_frame.geometry}
              material={materials.refrigerator_frame}
              visible={refrigeratorType === "Standard Fridge" ? true : false}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.refrigerator_logo.geometry}
              material={materials.refrigerator_logo}
              visible={refrigeratorType === "Standard Fridge" ? true : false}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.refrigerator_logo_frame.geometry}
              material={materials.refrigerator_logo_frame}
              visible={refrigeratorType === "Standard Fridge" ? true : false}
            />
          </mesh>
                <mesh
              castShadow
              receiveShadow
              geometry={nodes.outdoor_rated_fridge_1.geometry}
              material={materials.outdoor_rated_fridge}
              visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.outdoor_rated_fridge_2.geometry}
              material={materials.outdoor_rated_fridge_2}
              visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.outdoor_rated_fridge_3.geometry}
              material={materials.outdoor_rated_fridge_frame}
              visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.outdoor_rated_fridge_4.geometry}
              material={materials.outdoor_rated_fridge_handle}
              visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
            />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.frame.geometry}
            // material={materials.frame}
            material={materials.siding}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.siding.geometry}
            material={materials.siding}
          />
        </>
      ) : (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.qurtize_base_without_fridge.geometry}
            material={materials.siding}
          />
        </>
      )}
      {!(tileColorScheme === "No Tile") && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.frame.geometry}
            // material={materials.frame}
            material={materials.siding}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.top_side_frame.geometry}
            material={materials.top_side_frame}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.top.geometry}
            material={materials.top}
          />
        </>
      )}
      {tileColorScheme === "No Tile" && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.metal_side.geometry}
            material={materials.metal_side}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.metal_top.geometry}
            material={materials.top}
          />
        </>
      )}

      <mesh
        castShadow
        receiveShadow
        geometry={nodes.net.geometry}
        material={materials.net}
      />

      {/* <mesh position={[-0.0028, 0.4611, 0.0109]}>
          <boxGeometry args={[1.68, 0.854, 0.593]} />
          <meshStandardMaterial color={"#000"} />
        </mesh> */}

      {/* Bull griddle head */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["grill-30_bull_griddle"].geometry}
        material={materials["grill-30_bull_griddle"]}
        visible={grill === '30" Bull Griddle Head' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_bull_griddle_knoob_logo"].geometry}
          material={materials["grill-30_bull_griddle_knoob_logo"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_bull_griddle_logo"].geometry}
          material={materials["grill-30_bull_griddle_logo"]}
        />
        <animated.group
          position={[0.042, 1.062, -0.06]}
          rotation={rotation_Grill}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_bull_griddle_top"].geometry}
            material={materials["grill-30_bull_griddle_top"]}
            // position={[0.042, 1.062, -0.06]}
          />
        </animated.group>
      </mesh>
      {/* <mesh
          castShadow
          receiveShadow
          geometry={nodes['new-_griddle_head'].geometry}
          material={materials['new- griddle_head_logo_frame']}
          position={[-0.324, -0.019, 0.009]}
          visible={grill === '30" Bull Griddle Head' ? true : false}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes['new-_griddle_head_logo'].geometry}
            material={materials['new- griddle_head_logo_frame']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes['new-_griddle_head_logo_frame'].geometry}
            material={materials['new- griddle_head_logo_frame']}
          />
          <animated.group position={[0, 1.082, -0.067]} rotation={rotation_Grill}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes['new-_griddle_head_top'].geometry}
              material={materials['new- griddle_head_top']}
              // position={[0, 1.082, -0.067]}
            />
          </animated.group>
        </mesh> */}
      {sideBurner ? (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.side_burner.geometry}
            material={materials.side_burner_base}
          >
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.side_burner_knob_logo.geometry}
              material={materials.side_burner_knob_logo}
            />
            <animated.group
              position={[0.348, 1.005, -0.197]}
              rotation={rotation_Side_burner}
            >
              <animated.mesh
                castShadow
                receiveShadow
                geometry={nodes.side_burner_top.geometry}
                material={materials.side_burner_top}
                // position={[0.348, 1.005, -0.197]}
              />
            </animated.group>
          </mesh>
        </>
      ) : null}

      {siding !== "Faux Rock" && bottleOpener ? (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.bottle_opener.geometry}
            material={materials.bottle_opener}
          >
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.logo.geometry}
              material={materials.logo}
            />
          </mesh>
        </>
      ) : null}

      {/* lonestar grill */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["grill-30_lonestar_grill_head"].geometry}
        material={materials["grill-30_lonestar_grill_head"]}
        visible={grill === '30" Lonestar' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_lonestar_grill_head_alpha"].geometry}
          material={materials["grill-30_lonestar_grill_head_alpha"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_lonestar_grill_head_inner_black"].geometry}
          material={materials["grill-30_lonestar_grill_head_inner_black"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_lonestar_grill_head_inner_grill"].geometry}
          material={materials["grill-30_lonestar_grill_head_inner_grill"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={
            nodes["grill-30_lonestar_grill_head_top_frame_knob"].geometry
          }
          material={materials["grill-30_lonestar_grill_head_top_frame_knob"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={
            nodes["grill-30_lonestar_grill_head_top_frame_knoob_logo"].geometry
          }
          material={
            materials["grill-30_lonestar_grill_head_top_frame_knoob_logo"]
          }
        />
        <animated.group position={[0, 1.095, 0.021]} rotation={rotation_Grill}>
          <animated.mesh
            castShadow
            receiveShadow
            geometry={
              nodes["grill-30_lonestar_grill_head_top_frame_side_frame"]
                .geometry
            }
            material={
              materials["grill-30_lonestar_grill_head_top_frame_side_frame"]
            }
            // position={[0, 1.095, 0.021]}
          >
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_lonestar_grill_head_glass"].geometry}
              material={materials["grill-30_lonestar_grill_head_glass"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_lonestar_grill_head_handle"].geometry}
              material={materials["grill-30_lonestar_grill_head_handle"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={
                nodes["grill-30_lonestar_grill_head_inner_frame"].geometry
              }
              material={materials["grill-30_lonestar_grill_head_inner_frame"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={
                nodes["grill-30_lonestar_grill_head_top_frame"].geometry
              }
              material={materials["grill-30_lonestar_grill_head_top_frame"]}
            />
          </animated.mesh>
        </animated.group>
        <mesh
          castShadow
          receiveShadow
          geometry={
            nodes["grill-30_lonestar_grill_head_top_logo_frame"].geometry
          }
          material={materials["grill-30_lonestar_grill_head_top_logo_frame"]}
        />
      </mesh>
      {/* 30" Door/Drawer Combo */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["door-double_drawer_door_combo"].geometry}
        material={materials["door-double_drawer_door_combo"]}
        visible={door === '30" Door/Drawer Combo' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.double_drawer_door_combo_handle.geometry}
          material={materials.double_drawer_door_combo_handle}
        />
      </mesh>
      {/* 30" Door/Propane Drawer Combo */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["door-door_propane_drawer_combo"].geometry}
        material={materials["door-door_propane_drawer_combo"]}
        visible={door === '30" Door/Propane Drawer Combo' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.door_propane_drawer_combo_handle.geometry}
          material={materials.door_propane_drawer_combo_handle}
        />
      </mesh>
      {/* angus grill */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes["grill-30_agnus"].geometry}
        material={materials["grill-30_agnus"]}
        visible={grill === '30" Angus' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agngus_inner_grill"].geometry}
          material={materials["grill-30_agngus_inner_grill"]}
        />
        <animated.group position={[0, 1.108, 0.025]} rotation={rotation_Grill}>
          <animated.mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_agngus_inner_grill_side_frame"].geometry}
            material={materials["grill-30_agnus_top_frame"]}
          >
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_clock"].geometry}
              material={materials["grill-30_agnus_clock"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_handle"].geometry}
              material={materials["grill-30_agnus_handle"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_top"].geometry}
              material={materials["grill-30_agnus_top"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_top_frame"].geometry}
              material={materials["grill-30_agnus_top_frame"]}
            />
            <animated.mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_top_glass"].geometry}
              material={materials["grill-30_agnus_top_glass"]}
            />
          </animated.mesh>
        </animated.group>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_logo"].geometry}
          material={materials["grill-30_agnus_logo"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_stove_knob"].geometry}
          material={materials["grill-30_agnus_stove_knob"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_stove_knob_alpha"].geometry}
          material={materials["grill-30_agnus_stove_knob_alpha"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_stove_knob_logo"].geometry}
          material={materials["grill-30_agnus_stove_knob_logo"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus_wire"].geometry}
          material={materials["grill-30_agnus_wire"]}
        />
      </mesh>

      {umbrellHole ? (
        <>
          {/* <mesh
            castShadow
            receiveShadow
            geometry={nodes.top_with_umbrella.geometry}
            material={materials.island_top}
          /> */}
          {/* <mesh
              castShadow
              receiveShadow
              geometry={nodes.top_with_umbrella_2.geometry}
              material={materials.island_side}
            /> */}
          {/* <mesh
              castShadow
              receiveShadow
              geometry={nodes.top_with_umbrella_3.geometry}
              material={materials.island_bottom}
            /> */}
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.umbrella_hole.geometry}
            material={materials.umbrella_hole}
          />
          {/* <mesh position={[posx,posy,posz]}> */}
          <mesh position={[0.69, 0.981, -0.18]}>
            {/* <boxGeometry args={[argx, argy, argz]} /> */}
            <boxGeometry args={[0.07, 0.02, 0.07]} />
            <meshStandardMaterial color={"#000"} />
          </mesh>
        </>
      ) : null}
      <mesh castShadow receiveShadow geometry={nodes.plug.geometry} material={materials.plug} />
      {/* <mesh
          castShadow
          receiveShadow
          geometry={nodes.top_2.geometry}
          material={materials.side}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.top_3.geometry}
          material={materials.bottom}
        /> */}
    </group>
  );
}

export function Model_san_jaun_small() {
  const { nodes, materials, scene } = useGLTF("models/bull_outdoor_small.glb");
  const [finishes, setFinishes] = useState({});
  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === "Mainecottage"
    )
  );
  //  const { posx, posy, posz,argx,argy,argz} = useControls({
  //   posx: { value: 0, min: -2, max: 2, step: 0.001 },
  //   posy: { value: 0, min: -2, max: 2, step: 0.001 },
  //   posz: { value: 0, min: -2, max: 2, step: 0.001 },
  //   argx: { value: 0, min: -2, max: 2, step:0.001 },
  //   argy: { value: 0, min: -2, max: 2, step:0.001 },
  //   argz: { value: 0, min: -2, max: 2, step:0.001 },
  // });

  const {
    grill,
    setGrill,
    siding,
    setSiding,
    door,
    setDoor,
    colorScheme,
    setcolorScheme,
    loading,
    setLoading,
    isARReady,
    setIsARReady,
    ARModelSrc,
    setARModelSrc,
    ARUnicode,
    setARUnicode,
    isAR,
    setIsAR,
    umbrellHole,
    setUmbrellHole,
    bottleOpener,
    setBottleOpener,
  } = useContext(CurrentContext);

  useEffect(() => {
    if (siding === "Quartzite") {
      if (colorScheme === "Gray") {
        setFinishes({
          diffuseMap: "../textures/small/quartzite-gray.jpg",
          displacementMap: null,
          normalMap: "../textures/small/quartzite-normal.jpg",
          repeat: [3.424, 3.424],
        });
      }
      if (colorScheme === "Brown") {
        setFinishes({
          diffuseMap: "../textures/small/quartzite-brown.jpg",
          displacementMap: null,
          normalMap: "../textures/small/quartzite-normal.jpg",
          repeat: [3.424, 3.424],
        });
      }
    } else {
      if (colorScheme === "Gray") {
        setFinishes({
          diffuseMap: "../textures/small/fauxrock-gray.jpg",
          displacementMap: "../textures/small/rock_pattern_height.jpg",
          normalMap: null,
        });
      }
      if (colorScheme === "Brown") {
        setFinishes({
          diffuseMap: "../textures/small/fauxrock-brown.jpg",
          displacementMap: "../textures/small/rock_pattern_height.jpg",
          normalMap: null,
        });
      }
    }
  }, [siding, colorScheme]);

  useSetMaterialFinish(materials.siding, finishes);

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === "Bulloutdoor"
      )
    );
  }, [arRef]);

  useEffect(() => {
    console.log("enntered here out", isAR);
    if (isAR && currentScene) {
      console.log("enntered here");
      handleExportGLTF({
        currentScene,
        scene,
        fileName: "bull_outdoor",
        setLoading,
      }).then(({ file, unicode } = {}) => {
        console.log(file, unicode, "fileelele");
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group visible={true}>
      <group name={"Bulloutdoor"} dispose={null} visible={true} ref={arRef}>
        {/* 30" Double Door */}
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["door-double_door"].geometry}
          material={materials.double_door}
          visible={door === '30" Double Door' ? true : false}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.refrigerator.geometry}
          material={materials.refrigerator}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.net.geometry}
          material={materials.net}
        />

        <mesh position={[-0.0028, 0.4611, 0.0109]}>
          <boxGeometry args={[1.68, 0.854, 0.593]} />
          <meshStandardMaterial color={"#000"} />
        </mesh>

        <mesh
          castShadow
          receiveShadow
          geometry={nodes.siding.geometry}
          material={materials.siding}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.frame.geometry}
          // material={materials.frame}
          material={materials.siding}
        />
        {/* Bull griddle head */}

        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_bull_griddle"].geometry}
          material={materials["grill-30_bull_griddle"]}
          visible={grill === '30" Bull Griddle Head' ? true : false}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_bull_griddle_knoob_logo"].geometry}
            material={materials["grill-30_bull_griddle_knoob_logo"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_bull_griddle_logo"].geometry}
            material={materials["grill-30_bull_griddle_logo"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_bull_griddle_top"].geometry}
            material={materials["grill-30_bull_griddle_top"]}
            position={[0.042, 1.062, -0.06]}
          />
        </mesh>

        <mesh
          castShadow
          receiveShadow
          geometry={nodes.side_burner.geometry}
          material={materials.side_burner_base}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.side_burner_knob_logo.geometry}
            material={materials.side_burner_knob_logo}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.side_burner_top.geometry}
            material={materials.side_burner_top}
            position={[0.348, 1.005, -0.197]}
          />
        </mesh>
        {bottleOpener ? (
          <>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.bottle_opener.geometry}
              material={materials.bottle_opener}
              position={[-0.01, 0, 0]}
            >
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.logo.geometry}
                material={materials.logo}
              />
            </mesh>
          </>
        ) : null}

        {/* lonestar grill */}
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_lonestar_grill_head"].geometry}
          material={materials["grill-30_lonestar_grill_head"]}
          visible={grill === '30" Lonestar' ? true : false}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_lonestar_grill_head_alpha"].geometry}
            material={materials["grill-30_lonestar_grill_head_alpha"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes["grill-30_lonestar_grill_head_inner_black"].geometry
            }
            material={materials["grill-30_lonestar_grill_head_inner_black"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes["grill-30_lonestar_grill_head_inner_grill"].geometry
            }
            material={materials["grill-30_lonestar_grill_head_inner_grill"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes["grill-30_lonestar_grill_head_top_frame_knob"].geometry
            }
            material={materials["grill-30_lonestar_grill_head_top_frame_knob"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes["grill-30_lonestar_grill_head_top_frame_knoob_logo"]
                .geometry
            }
            material={
              materials["grill-30_lonestar_grill_head_top_frame_knoob_logo"]
            }
          />
          <mesh
            castShadow
            receiveShadow
            geometry={
              nodes["grill-30_lonestar_grill_head_top_frame_side_frame"]
                .geometry
            }
            material={
              materials["grill-30_lonestar_grill_head_top_frame_side_frame"]
            }
            position={[0, 1.095, 0.021]}
          >
            <mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_lonestar_grill_head_glass"].geometry}
              material={materials["grill-30_lonestar_grill_head_glass"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_lonestar_grill_head_handle"].geometry}
              material={materials["grill-30_lonestar_grill_head_handle"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={
                nodes["grill-30_lonestar_grill_head_inner_frame"].geometry
              }
              material={materials["grill-30_lonestar_grill_head_inner_frame"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={
                nodes["grill-30_lonestar_grill_head_top_frame"].geometry
              }
              material={materials["grill-30_lonestar_grill_head_top_frame"]}
            />
          </mesh>
        </mesh>
        {/* 30" Door/Drawer Combo */}
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["door-double_drawer_door_combo"].geometry}
          material={materials["door-double_drawer_door_combo"]}
          visible={door === '30" Door/Drawer Combo' ? true : false}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.double_drawer_door_combo_handle.geometry}
            material={materials.double_drawer_door_combo_handle}
          />
        </mesh>
        {/* 30" Door/Propane Drawer Combo */}
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["door-door_propane_drawer_combo"].geometry}
          material={materials["door-door_propane_drawer_combo"]}
          visible={door === '30" Door/Propane Drawer Combo' ? true : false}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.door_propane_drawer_combo_handle.geometry}
            material={materials.door_propane_drawer_combo_handle}
          />
        </mesh>
        {/* angus grill */}
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["grill-30_agnus"].geometry}
          material={materials["grill-30_agnus"]}
          visible={grill === '30" Angus' ? true : false}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_agngus_inner_grill"].geometry}
            material={materials["grill-30_agngus_inner_grill"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_agngus_inner_grill_side_frame"].geometry}
            material={materials["grill-30_agnus_top_frame"]}
            position={[0, 1.108, 0.025]}
          >
            <mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_clock"].geometry}
              material={materials["grill-30_agnus_clock"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_handle"].geometry}
              material={materials["grill-30_agnus_handle"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_top"].geometry}
              material={materials["grill-30_agnus_top"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_top_frame"].geometry}
              material={materials["grill-30_agnus_top_frame"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes["grill-30_agnus_top_glass"].geometry}
              material={materials["grill-30_agnus_top_glass"]}
            />
          </mesh>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_agnus_logo"].geometry}
            material={materials["grill-30_agnus_logo"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_agnus_stove_knob"].geometry}
            material={materials["grill-30_agnus_stove_knob"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_agnus_stove_knob_alpha"].geometry}
            material={materials["grill-30_agnus_stove_knob_alpha"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_agnus_stove_knob_logo"].geometry}
            material={materials["grill-30_agnus_stove_knob_logo"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["grill-30_agnus_wire"].geometry}
            material={materials["grill-30_agnus_wire"]}
          />
        </mesh>

        {umbrellHole ? (
          <>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.top_with_umbrella_1.geometry}
              material={materials.island_top}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.top_with_umbrella_2.geometry}
              material={materials.island_side}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.top_with_umbrella_3.geometry}
              material={materials.island_bottom}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.umbrella_hole.geometry}
              material={materials.umbrella_hole}
            />
            {/* <mesh position={[posx,posy,posz]}> */}
            <mesh position={[0.69, 0.981, -0.18]}>
              {/* <boxGeometry args={[argx, argy, argz]} /> */}
              <boxGeometry args={[0.07, 0.02, 0.07]} />
              <meshStandardMaterial color={"#000"} />
            </mesh>
          </>
        ) : null}

        <mesh
          castShadow
          receiveShadow
          geometry={nodes.top_1.geometry}
          material={materials.top}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.top_2.geometry}
          material={materials.side}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.top_3.geometry}
          material={materials.bottom}
        />
      </group>
    </group>
  );
}
